const state = {
    global: {
        app: {
            url: window.APP_URL,
            path: window.APP_URL.replace(location.protocol + "//" + location.host + "/", ""),
        },
        loader: {
            label: "",
            description: "",
            isLoading: false,
            overlay: false,
        },
        flashMessage: {
            color: "",
            message: "",
            errorList: [],
        },
        collections: {
            titles: [],
            employment_statuses: [],
            residency: [],
            asset_values: [],
            countries: [],
            submission_statuses: {
                "In Progress": {
                    bgColorClass: "bg-grey/[.15]",
                    borderColorClass: "outline-grey/[.15]",
                    textColorClass: "text-grey",
                    icon: "in-progress",
                },
                Submitted: {
                    bgColorClass: "bg-light-blue/[.15]",
                    borderColorClass: "outline-light-blue/[.15]",
                    textColorClass: "text-light-blue",
                    icon: "submitted",
                },
                "Under Review": {
                    bgColorClass: "bg-warning/[.15]",
                    borderColorClass: "outline-warning/[.15]",
                    textColorClass: "text-warning",
                    icon: "in-review",
                },
                "First Approval": {
                    bgColorClass: "bg-success/[.15]",
                    borderColorClass: "outline-success/[.15]",
                    textColorClass: "text-success",
                    icon: "first-approval",
                },
                "Second Approval": {
                    bgColorClass: "bg-success/[.15]",
                    borderColorClass: "outline-success/[.15]",
                    textColorClass: "text-success",
                    icon: "approved",
                },
                Approved: {
                    bgColorClass: "bg-success/[.15]",
                    borderColorClass: "outline-success/[.15]",
                    textColorClass: "text-success",
                    icon: "approved",
                },
                Reject: {
                    bgColorClass: "bg-error/[.15]",
                    borderColorClass: "outline-error/[.15]",
                    textColorClass: "text-error",
                    icon: "rejected",
                },
                Rejected: {
                    bgColorClass: "bg-error/[.15]",
                    borderColorClass: "outline-error/[.15]",
                    textColorClass: "text-error",
                    icon: "rejected",
                },
            },
        },
        submission_errors: {
            show: false,
            isServerError: false,
            isIdDocumentError: "",
            isSelfieError: "",
        },
        submission_success: false,
        modals: {
            approval: {
                show: false,
                approval_type: ""
            }
        }
    },
};

const getters = {
    global: (state) => state.global,
    collections: (state) => state.global.collections,
};

const actions = {
    showHideGlobalLoader({ dispatch, commit }, { isLoading, label, overlay, description = "" }) {
        commit("setGlobalLoading", { isLoading, label, overlay, description });
    },
    showHideSubmissionErrorsModal({ dispatch, commit }, data) {
        commit("setSubmissionErrorsModal", data);
    },
    isSubmissionSuccess({ dispatch, commit }, success) {
        commit("setIsSubmissionSuccess", success);
    },
    setGlobalFlashResponse({ dispatch, commit }, { color = "error", message, errorList }) {
        commit("doSetGlobalFlashResponse", { color, message, errorList });
    },
    resetGlobalFlashResponse({ dispatch, commit }) {
        commit("doResetGlobalFlashResponse");
    },
    doGetCollectionData({ dispatch, commit }, collectionType) {
        return new Promise((resolve, reject) => {
            axios.get("/collections/" + collectionType).then(
                (response) => {
                    commit("setCollectionData", { name: collectionType, data: response.data });
                    resolve(response.data);
                },
                (error) => {
                    console.log(error);
                    reject(error);
                }
            );
        });
    },
    showHideApprovalModal({ commit }, data = {}) {
        commit("setApprovalModal", data);
    },
};
const mutations = {
    setGlobalLoading: (state, { isLoading, label, overlay, description = "" }) => {
        window.scrollTo(0, 0); // Ensure we are scrolled to the top
        document.body.style.overflow = overlay ? "hidden" : "initial"; // Add relevant overflow on body when loader is enabled/disabled

        state.global.loader.isLoading = isLoading;
        state.global.loader.label = label;
        state.global.loader.overlay = overlay;
        state.global.loader.description = description;
    },
    doSetGlobalFlashResponse: (state, { color, message, errorList }) => {
        state.global.flashMessage.color = color;
        state.global.flashMessage.message = message;
        state.global.flashMessage.errorList = errorList;
    },
    doResetGlobalFlashResponse: (state) => {
        state.global.flashMessage = {
            color: "error",
            message: "",
            errorList: [],
        };
    },
    setCollectionData: (state, collection) => {
        state.global.collections[collection.name] = collection.data;
    },
    setSubmissionErrorsModal: (state, data) => {
        window.scrollTo(0, 0); // Ensure we are scrolled to the top
        document.body.style.overflow = data.show ? "hidden" : "initial"; // Add relevant overflow on body when loader is enabled/disabled
        state.global.submission_errors = data;
    },
    setIsSubmissionSuccess: (state, isSuccess) => {
        window.scrollTo(0, 0); // Ensure we are scrolled to the top
        document.body.style.overflow = isSuccess ? "hidden" : "initial"; // Add relevant overflow on body when loader is enabled/disabled
        state.global.submission_success = isSuccess;
    },
    setApprovalModal: (state, data = {}) => {
        state.global.modals.approval.show = data.show ?? false;
        state.global.modals.approval.approval_type = data.approvalType ?? '';
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
